module.exports = __webpack_public_path__ + "static/media/shield.2f727393.svg";